/**
 * Deutsche Endnutzertexte für die Mitglieder-RPCs.
 * Technische Details (Funktionsnamen, Tabellen, PostgREST-Codes) gehören in die Konsole.
 */

export const MEMBER_ERROR_TEXT = {
  lastAdmin:
    "Es muss mindestens eine aktive Administration im Verein bleiben.",
  forbidden: "Dafür fehlt dir die Berechtigung.",
  adminRole:
    "Nur die Administration darf die Rolle Administration vergeben oder entziehen.",
  adminMemberStatus:
    "Nur die Administration darf Mitgliedschaften mit der Rolle Administration deaktivieren.",
  minRole: "Jedes Mitglied braucht mindestens eine Rolle.",
  invitedStatus:
    "Einladungen bleiben unberührt. Nur der Wechsel zwischen aktiv und deaktiviert ist erlaubt.",
  invalidInput: "Diese Eingabe ist nicht zulässig.",
  selfDisable: "Du kannst dich nicht selbst deaktivieren.",
  retry: "Das hat gerade nicht geklappt. Bitte versuche es erneut.",
  generic: "Das hat nicht geklappt. Bitte versuche es erneut.",
} as const;

function readError(error: unknown): { message: string; code: string } {
  if (typeof error === "string") return { message: error, code: "" };
  if (!error || typeof error !== "object") return { message: "", code: "" };
  const row = error as { message?: unknown; code?: unknown; details?: unknown };
  const message = [row.message, row.details]
    .filter((part) => typeof part === "string" && part.trim())
    .join(" ");
  const code = typeof row.code === "string" ? row.code : "";
  return { message, code };
}

function isRetryable(message: string, code: string): boolean {
  if (code === "40P01") return true;
  return /deadlock detected|failed to fetch|network request failed|networkerror|timeout|aborted|load failed/i.test(
    message,
  );
}

export function mapMemberError(error: unknown): string {
  const { message, code } = readError(error);
  const text = message.trim();

  if (text.includes("LAST_ADMIN") || code === "23514") {
    return MEMBER_ERROR_TEXT.lastAdmin;
  }
  if (/mindestens eine rolle/i.test(text)) {
    return MEMBER_ERROR_TEXT.minRole;
  }
  if (/eigene mitgliedschaft/i.test(text)) {
    return MEMBER_ERROR_TEXT.selfDisable;
  }
  if (/admin-rolle/i.test(text)) {
    return MEMBER_ERROR_TEXT.adminRole;
  }
  if (/admin-mitglied/i.test(text)) {
    return MEMBER_ERROR_TEXT.adminMemberStatus;
  }
  if (text === "not allowed" || code === "42501") {
    return MEMBER_ERROR_TEXT.forbidden;
  }
  if (code === "22023") {
    if (/einladungen bleiben/i.test(text)) return MEMBER_ERROR_TEXT.invitedStatus;
    return MEMBER_ERROR_TEXT.invalidInput;
  }
  if (isRetryable(text, code)) {
    return MEMBER_ERROR_TEXT.retry;
  }
  return MEMBER_ERROR_TEXT.generic;
}
